import React from 'react'

export const OfferCard = () => {
    return (
        <>
            {/* ===== DEAL BANNER ===== */}
            <section style={{ background: "var(--light-bg)", padding: "0 0 52px" }}>
                <div className="container">
                    <div className="zzx_deal-banner">
                        <div className="row align-items-center">
                            <div className="col-lg-8">
                                <span
                                    className="badge mb-2"
                                    style={{
                                        background: "var(--accent)",
                                        color: "#222",
                                        fontSize: "0.8rem",
                                        padding: "6px 14px"
                                    }}
                                >
                                    🔥 Limited Time Offer
                                </span>
                                <h2>
                                    Monsoon Madness Sale
                                    <br />
                                    Up to
                                    <span style={{ color: "var(--accent)" }}>40% Off</span> on Resorts
                                </h2>
                                <p>
                                    Book any resort stay before July 31 and get massive discounts plus
                                    free breakfast for 2. No promo code needed.
                                </p>
                                <div className="d-flex gap-3 flex-wrap">
                                    <button className="zzx_btn-deal">Grab the Deal</button>
                                    <button
                                        style={{
                                            background: "transparent",
                                            border: "2px solid rgba(255, 255, 255, 0.5)",
                                            color: "#fff",
                                            borderRadius: 10,
                                            padding: "10px 24px",
                                            fontFamily: '"Nunito", sans-serif',
                                            fontWeight: 700,
                                            fontSize: "0.95rem",
                                            cursor: "pointer"
                                        }}
                                    >
                                        Learn More
                                    </button>
                                </div>
                            </div>
                            <div className="col-lg-4 text-center mt-4 mt-lg-0">
                                <div
                                    style={{
                                        background: "rgba(255, 255, 255, 0.1)",
                                        borderRadius: 16,
                                        padding: 24,
                                        backdropFilter: "blur(10px)"
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "3rem",
                                            fontWeight: 900,
                                            color: "var(--accent)",
                                            lineHeight: 1
                                        }}
                                    >
                                        40%
                                    </div>
                                    <div
                                        style={{
                                            color: "rgba(255, 255, 255, 0.85)",
                                            fontWeight: 700,
                                            fontSize: "1rem"
                                        }}
                                    >
                                        OFF Selected Resorts
                                    </div>
                                    <div
                                        style={{
                                            color: "rgba(255, 255, 255, 0.6)",
                                            fontSize: "0.82rem",
                                            fontWeight: 600,
                                            marginTop: 4
                                        }}
                                    >
                                        Book by July 31, 2025
                                    </div>
                                    <div
                                        style={{
                                            borderTop: "1px solid rgba(255, 255, 255, 0.15)",
                                            marginTop: 16,
                                            paddingTop: 12,
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 20
                                        }}
                                    >
                                        <div style={{ textAlign: "center" }}>
                                            <div
                                                style={{
                                                    color: "var(--accent)",
                                                    fontWeight: 900,
                                                    fontSize: "1.1rem"
                                                }}
                                            >
                                                2.4M+
                                            </div>
                                            <div
                                                style={{
                                                    color: "rgba(255, 255, 255, 0.6)",
                                                    fontSize: "0.75rem",
                                                    fontWeight: 700
                                                }}
                                            >
                                                Properties
                                            </div>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <div
                                                style={{
                                                    color: "var(--accent)",
                                                    fontWeight: 900,
                                                    fontSize: "1.1rem"
                                                }}
                                            >
                                                220+
                                            </div>
                                            <div
                                                style={{
                                                    color: "rgba(255, 255, 255, 0.6)",
                                                    fontSize: "0.75rem",
                                                    fontWeight: 700
                                                }}
                                            >
                                                Countries
                                            </div>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <div
                                                style={{
                                                    color: "var(--accent)",
                                                    fontWeight: 900,
                                                    fontSize: "1.1rem"
                                                }}
                                            >
                                                50M+
                                            </div>
                                            <div
                                                style={{
                                                    color: "rgba(255, 255, 255, 0.6)",
                                                    fontSize: "0.75rem",
                                                    fontWeight: 700
                                                }}
                                            >
                                                Travellers
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}
